import type React from 'react'

import { PORT_STROKE_COLOR } from '../constants/port-style'

const PORT_SEQ_FONT_SIZE = 10

/**
 * A port square's centered chain-sequence number, shared by `PortSquare` and `LinkedOutPortSquare`.
 *
 * Only the `<text>` lives here; each caller keeps its own counter-rotating `<g>` wrapper. That is
 * deliberate: `LinkedOutPortSquare` swaps this wrapper with its hover "×" group in the same slot,
 * and keeping both as plain `<g>` elements there lets React reuse the node exactly as it always has.
 */
export function PortSeqNumeral({ seq }: { seq: number }): React.JSX.Element {
  return (
    <text
      x={0}
      y={0}
      textAnchor="middle"
      dominantBaseline="central"
      fontSize={PORT_SEQ_FONT_SIZE}
      fill={PORT_STROKE_COLOR}
      pointerEvents="none"
    >
      {seq}
    </text>
  )
}
